var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 11.9297H13.7583M2.5 4.42973V16.0964C2.5 17.0169 3.24619 17.7631 4.16667 17.7631H15.8333C16.7538 17.7631 17.5 17.0169 17.5 16.0964V7.76306C17.5 6.84259 16.7538 6.0964 15.8333 6.0964L4.16667 6.09639C3.24619 6.09639 2.5 5.3502 2.5 4.42973ZM2.5 4.42973C2.5 3.50925 3.24619 2.76306 4.16667 2.76306H14.1667M14.1667 11.9297C14.1667 12.1598 13.9801 12.3464 13.75 12.3464C13.5199 12.3464 13.3333 12.1598 13.3333 11.9297C13.3333 11.6996 13.5199 11.5131 13.75 11.5131C13.9801 11.5131 14.1667 11.6996 14.1667 11.9297Z",
    stroke: "#667185",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.9553e9f871734e7a83bb7a3fabd24b98.svg";
export { ForwardRef as ReactComponent };